module.exports = __webpack_public_path__ + "static/media/teacher.83757f27.png";